import ImagesHomeBottleOfTheDayRibbornSvg from '@/public/images/home/bottle-of-the-day/ribborn.svg';

export { ImagesHomeBottleOfTheDayRibbornSvg };
